import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useAuth } from '../auth/useAuth.js'
import { useDataLoader } from '../useDataLoader.js'
import { isFuture } from '../../utils/dateUtils.js'
import { quotesService } from '../../services/index.js'

export function useTasksTodayCount() {
  const { user: currentUser } = useAuth()
  const tasks = ref([])
  const lastLoadTime = ref(null)
  
  const { loading, loadData } = useDataLoader({
    showErrorToast: false
  })

  const todayTasksCount = computed(() => {
    // Compter uniquement les tâches d'aujourd'hui (pas futures)
    return tasks.value.filter(task => {
      if (!task.next_action_date) return false
      return !isFuture(task.next_action_date)
    }).length
  })

  const loadTasksCount = async (force = false) => {
    if (!currentUser.value?.id) return
    
    // Ne pas recharger si on a déjà chargé il y a moins de 30 secondes (sauf si force = true)
    const now = Date.now()
    if (!force && lastLoadTime.value && (now - lastLoadTime.value) < 30000) {
      return
    }
    
    try {
      const data = await loadData(() => quotesService.getTasksToday(currentUser.value.id))
      tasks.value = data.quotes || []
      lastLoadTime.value = now
    } catch (err) {
      console.error('Error loading tasks count:', err)
    }
  }

  // Écouter les événements de modification de tâches
  const handleTaskUpdate = () => {
    loadTasksCount(true) // Force le rechargement
  }

  // Recharger quand l'utilisateur change
  watch(() => currentUser.value?.id, (newId) => {
    if (newId) {
      loadTasksCount()
    } else {
      tasks.value = []
    }
  })

  onMounted(() => {
    if (currentUser.value?.id) {
      loadTasksCount()
    }
    // Écouter les événements de modification de tâches
    window.addEventListener('tasks-updated', handleTaskUpdate)
  })

  onUnmounted(() => {
    window.removeEventListener('tasks-updated', handleTaskUpdate)
  })

  return {
    todayTasksCount,
    loadTasksCount,
    loading
  }
}

// Fonction utilitaire pour déclencher l'événement de mise à jour
export function notifyTasksUpdated() {
  window.dispatchEvent(new CustomEvent('tasks-updated'))
}

